<template>
    <form class="component-sign-up-form" :onsubmit="'return false'" :class="['subscription-form', form.class]" v-on:submit.prevent="subscribe">
        <div class="p-0 mb-3 w-full">
            <label :for="'payload-email-address-' + id" class="!inline">
                <input
                    class="email md:w-1/2 pr-4 pl-4 w-full !border-0 shadow-md pb-1 !placeholder:text-sm !placeholder:text-slate-700"
                    aria-labelledby="payload-enter-email"
                    :aria-label="translations.email_enter_email"
                    :placeholder="translations.email_enter_email"
                    :id="'payload-email-address' + id"
                    v-model="payload.email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    name="email"
                    type="email"
                    required
                />
            </label>
            <input name="country" v-bind:value="payload.country" type="hidden" />
            <input name="current_url" v-bind:value="payload.current_url" type="hidden" />
            <input name="us_state" v-bind:value="payload.us_state" type="hidden" />
            <input name="region" v-bind:value="payload.us_state" type="hidden" />
            <input name="hidden_input" v-bind:value="payload.hidden_input" style="display: none"/>
            <input name="debug" v-bind:value="payload.debug" type="hidden" />
            <input name="product_type_feature" v-bind:value="payload.product_type_feature" type="hidden"/>

            <button type="submit" class="button-blue button-inline m-0 md:ml-4 pb-2 md:w-2/5 pr-4 pl-4 w-full">
                {{ translations.subscribe_button_text }}
            </button>
        </div>
        <div class="md:flex mb-3">
            <div class="agree-text text-left p-0">
                <div class="w-full flex items-stretch">
                    <div :id="'fake-checkbox-container-' + id" style="display: inline-block;">
                        <fake-checkbox-tw
                        :id="id"
                        :check="fakeCheckbox.checked"
                        :required="fakeCheckbox.required"
                        :name="fakeCheckbox.name"
                        :validation-message="translations.checkbox_validation_error"
                        >
                        </fake-checkbox-tw>
                    </div>
                    <div class="ml-2 flex">
                        <span @click="flip" :id="'label-' + id" class="agree-message">
                            <p class="!text-gdc-gray-700" v-html="translations.agree_message"></p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <button class="button-blue inline md:hidden mb-3 md:ml-2 md:w-2/5 pr-4 pl-4 w-full" type="submit" :disabled="commencing === true">
            {{ translations.subscribe_button_text }}
        </button>
    </form>
</template>

<script>
import { NewsLetterSubscription } from '../../../NewsLetterSubscription';

export default {
    mounted() {
        this.id = this.$root.id;
        this.payload.current_url = this.$root.current_url;
        this.payload.country = this.$root.country;
        this.payload.hidden_input = this.$root.hidden_input;
        this.payload.debug = this.$root.class;
        this.payload.product_type_feature = this.$root.product_type_feature;
        this.fakeCheckbox = this.$root.fakeCheckbox;
        this.translations = this.$root.translations;
        this.form.class = this.$root.class;
        this.form.showImage = this.$root.showImage;

        if (this.$root.class === 'email-capture-static') {
            this.payload.debug = 'email-capture-top';
        }

        if (this.$root.us_state) {
            this.payload.us_state = this.$root.us_state;
        }
    },

    data() {
        return {
            id: null,
            form: {
                class: 'email-capture-static',
                showImage: null,
            },
            payload: {
                current_url: null,
                country: 'US',
                email: null,
                us_state: null,
                debug: null,
                product_type_feature: null,
            },
            hidden_input: null,
            translations: {
                email_enter_email: null,
                subscribe_button_text: null,
                agree_message: null,
                input_validation_error: null,
                checkbox_validation_error: null,
                email_validation_error: null,
            },
            commencing: false,
            subscribed: null,
            fakeCheckbox: {
                checked: false,
                required: true,
                name: null,
            },
        };
    },
    methods: {
        flip() {
            this.$children[0].flipState().toggleCheckbox();
        },
        subscribe(event) {
            let self = this;
            self.commencing = true;

            let data = $(event.target).serializeArray();

            let payload = {};
            data.forEach(function (item) {
                payload[item.name] = item.value;
            });

            let subscription = new NewsLetterSubscription();

            subscription.subscribe(payload).then(function (response) {
                if (
                    typeof response.status !== 'undefined' &&
                    response.status.toLowerCase() === 'subscribed' &&
                    payload.hidden_input === ''
                ) {
                    self.subscribed = true;
                    $(document).trigger('newsletter.subscribed', [true, self.id]);
                } else {
                    self.subscribed = false;
                    $(document).trigger('newsletter.subscribed', [false, self.id]);
                }
                self.commencing = false;
            });
        },
        setEmailInputValidationMessage(event) {
            if (event.target.validity.typeMismatch) {
                event.target.setCustomValidity(this.translations.email_validation_error);
            } else if (event.target.validity.valueMissing) {
                event.target.setCustomValidity(this.translations.input_validation_error);
            } else {
                event.target.setCustomValidity('');
            }
        },
    },
};
</script>
